module.exports = __webpack_public_path__ + "static/20-15-1560ed8a8a2b2b574f838754734dd8d3.jpg";